(function () {
  function init() {
    var input = document.getElementById('pa-search');
    var grid = document.getElementById('pa-grid');
    var empty = document.getElementById('pa-no-results');
    var sort = document.getElementById('pa-sort');
    if (input && grid && empty) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.pa-product'));
      input.addEventListener('input', function () {
        var query = input.value.trim().toLocaleLowerCase('da');
        var visible = 0;
        cards.forEach(function (card) {
          var matches = (card.getAttribute('data-search') || '').toLocaleLowerCase('da').indexOf(query) !== -1;
          card.hidden = !matches;
          if (matches) visible++;
        });
        empty.hidden = visible > 0;
      });
    }
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      url.hash = 'pa-products';
      window.location.assign(url.toString());
    });
  }
  var _init = init; init = function () { _init(); motion(); carousel(); };

  function carousel() {
    var track = document.querySelector('.pa-hero__track');
    if (!track) return;
    var rail = track.querySelector('.pa-hero__rail');
    var original = Array.prototype.slice.call(rail.querySelectorAll('.pa-hero__product'));
    if (original.length < 4 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    original.slice(0, 3).forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      rail.appendChild(clone);
    });
    var index = 0;
    var timer;
    function updateFocus() {
      original.forEach(function (item, i) {
        item.tabIndex = i >= index && i < index + 3 ? 0 : -1;
      });
    }
    function advance() {
      index++;
      rail.style.transition = 'transform .85s cubic-bezier(.42,0,.2,1)';
      rail.style.transform = 'translateX(-' + (index * 100 / 3) + '%)';
      updateFocus();
    }
    rail.addEventListener('transitionend', function (event) {
      if (event.target !== rail || index < original.length) return;
      rail.style.transition = 'none';
      index = 0;
      rail.style.transform = 'translateX(0)';
      updateFocus();
    });
    function start() { if (!timer && !document.hidden) timer = window.setInterval(advance, 3300); }
    function stop() { window.clearInterval(timer); timer = null; }
    track.addEventListener('mouseenter', stop);
    track.addEventListener('mouseleave', start);
    track.addEventListener('focusin', stop);
    track.addEventListener('focusout', function (event) { if (!track.contains(event.relatedTarget)) start(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    updateFocus();
    start();
  }

  function motion() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var hero = document.querySelector('.pa-hero');
    if (hero && !hero.querySelector('.pa-leaves')) {
      var box = document.createElement('div'); box.className = 'pa-leaves'; box.setAttribute('aria-hidden', 'true');
      var colors = ['#b5652e', '#c98a3a', '#8f3f1f', '#d4a24c'];
      var n = window.innerWidth < 720 ? 4 : 8;
      for (var i = 0; i < n; i++) {
        var l = document.createElement('span'); l.className = 'pa-leaf';
        l.style.left = (5 + Math.random() * 90) + '%';
        l.style.setProperty('--s', (12 + Math.random() * 12) + 'px');
        l.style.setProperty('--c', colors[i % 4]);
        l.style.setProperty('--d', (11 + Math.random() * 8) + 's');
        l.style.setProperty('--delay', (-Math.random() * 14) + 's');
        l.style.setProperty('--x', (Math.random() * 120 - 60) + 'px');
        box.appendChild(l);
      }
      hero.insertBefore(box, hero.firstChild);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    var groups = ['.pa-grid .pa-product', '.pa-guide__list > div', '.pa-faq__items details', '.pa-section-head', '.pa-outro .pa-wrap > *'];
    groups.forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el, idx) {
        if (el.classList.contains('pa-reveal')) return;
        el.classList.add('pa-reveal'); el.style.setProperty('--i', idx % 4); io.observe(el);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
